export var ENibBiz;
(function (ENibBiz) {
    ENibBiz["FOOD_GROUP"] = "-3";
    // 美食团购
    ENibBiz["HOTEL"] = "-4";
    // 酒店民宿
    ENibBiz["DAO_ZONG_XIU_YU"] = "-5";
    // 到综休闲娱乐
    ENibBiz["DAO_ZONG_FAMILY_SERVICE"] = "-6";
    // 到综家庭服务
    ENibBiz["DAO_ZONG_BEAUTY_HEALTH"] = "-7";
    // 到综变美健康
    ENibBiz["TRIP_OR_TRANSPORT"] = "-8";
    // 旅游出行
})(ENibBiz || (ENibBiz = {}));
export var EResultCode;
(function (EResultCode) {
    EResultCode[EResultCode["SUCCESS"] = 0] = "SUCCESS";
    // 成功
    EResultCode[EResultCode["ILLEGAL_PARAM"] = 101] = "ILLEGAL_PARAM";
    // 参数错误
    EResultCode[EResultCode["UN_LOGIN"] = 102] = "UN_LOGIN";
    // 未登录
    EResultCode[EResultCode["ISSUE_FAIL"] = 103] = "ISSUE_FAIL";
    // 发券失败
    EResultCode[EResultCode["NOT_START"] = 104] = "NOT_START";
    // 活动还没开始
    EResultCode[EResultCode["ALREADY_END"] = 105] = "ALREADY_END";
    // 活动已结束
    EResultCode[EResultCode["RISK_CONTROL"] = 106] = "RISK_CONTROL";
    // 不符合活动规则
    EResultCode[EResultCode["STOCK_NOT_ENOUGH"] = 107] = "STOCK_NOT_ENOUGH";
    // 库存不足
    EResultCode[EResultCode["NO_USER_QUALIFICATION"] = 108] = "NO_USER_QUALIFICATION";
    // 无领取资格，用户画像不通过
    EResultCode[EResultCode["ISSUE_NUM_LIMIT"] = 109] = "ISSUE_NUM_LIMIT";
    // 达到领取上限
    EResultCode[EResultCode["RENDER_FAILED"] = 110] = "RENDER_FAILED";
    // 发券预校验失败
    EResultCode[EResultCode["RATE_LIMIT"] = 112] = "RATE_LIMIT";
    // 参与人数过多
    EResultCode[EResultCode["ACTIVITY_OFF_LINE"] = 113] = "ACTIVITY_OFF_LINE";
    // 没有在线活动
})(EResultCode || (EResultCode = {}));
export var ECouponType;
(function (ECouponType) {
    ECouponType[ECouponType["COMMON_COUPON"] = 0] = "COMMON_COUPON";
    // 满减券
    ECouponType[ECouponType["DYNAMIC_AMOUNT_COUPON"] = 2] = "DYNAMIC_AMOUNT_COUPON";
    // 动态金额券
})(ECouponType || (ECouponType = {}));
